import { render, staticRenderFns } from "./Tariffs.vue?vue&type=template&id=3c552b98&scoped=true"
import script from "./Tariffs.vue?vue&type=script&lang=js"
export * from "./Tariffs.vue?vue&type=script&lang=js"
import style0 from "./Tariffs.vue?vue&type=style&index=0&id=3c552b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c552b98",
  null
  
)

export default component.exports